export default "__VITE_ASSET__3b3d7326__"